module.exports = __webpack_public_path__ + "img/travelConsum.b0407df9.png";